import React, { useState } from 'react';
import Icon from '@mdi/react';
import { toast } from 'react-toastify';
import { mdiTrashCanOutline } from '@mdi/js';
import DefaultFileImage from '../../../assets/images/FileType/defaultFile.svg';
import dlIcon from '../../../assets/icons/dlicon.png';
import eyeIcon from '../../../assets/icons/eyeicon.png';
import { FileUtil } from '../../../utils';
import DisplayModal from '../DisplayModal/DisplayModal';

import './SelectedFiles.scss';

export default function SelectedFiles({
  files = [],
  handleDeleteFile = null,
  display,
  download,
}) {
  const [isDisplayModalOpen, setDisplayModalOpen] = useState(false);
  const [displayModalFile, setDisplayModalFile] = useState(null);

  const generateIcon = file => {
    const icon = DefaultFileImage;
    return (
      <img
        src={icon}
        style={{
          width: '25px',
          height: '25px',
        }}
        alt={`File type icon for ${file.name}`}
      />
    );
  };

  const handleFileDisplay = file => {
    setDisplayModalFile(file);
    setDisplayModalOpen(true);
  };

  const handleFileDownload = file => {
    if (!file) {
      toast.error('No file selected for download', {
        className: 'toast-error',
      });
      return;
    }
    FileUtil.downloadBlobFile(file, file.name);
  };

  return (
    <div>
      <div className="selected-files-list d-flex flex-column gap-2">
        {files &&
          files?.length > 0 &&
          files?.map(file => (
            <div
              key={`${file.name}-${file.lastModified}`}
              className="d-flex align-items-center file-row"
              style={{
                backgroundColor: '#F8F9FA',
                padding: '6px 18px',
                borderRadius: '8px',
              }}
            >
              <div className="left-side d-flex flex-row gap-2 align-items-center">
                {generateIcon(file)}
                <div className="d-flex flex-column file-middle">
                  <span className="file-name">{file.name}</span>
                  <span className="file-size">
                    {Math.round(file.size / 1024)} KB
                  </span>
                </div>
              </div>
              <div className="file-actions">
                {display && (
                  <span
                    className="me-2 cursor-pointer"
                    onClick={() => handleFileDisplay(file)}
                    title="View File"
                  >
                    <img src={eyeIcon} alt="View" style={{ height: '15px' }} />
                  </span>
                )}
                {download && (
                  <span
                    className="me-2 cursor-pointer"
                    onClick={() => handleFileDownload(file)}
                    title="Download File"
                  >
                    <img
                      src={dlIcon}
                      alt="Download"
                      style={{ height: '15px' }}
                    />
                  </span>
                )}
                {handleDeleteFile && (
                  <span>
                    <Icon
                      className="cursor-pointer"
                      path={mdiTrashCanOutline}
                      size={0.8}
                      style={{ color: '#017EBD' }}
                      onClick={() => handleDeleteFile(file)}
                      title="Delete File"
                    />
                  </span>
                )}
              </div>
            </div>
          ))}
      </div>
      <DisplayModal
        isModalOpen={isDisplayModalOpen}
        toggle={() => setDisplayModalOpen(false)}
        title="View Attachments"
        file={displayModalFile}
      />
    </div>
  );
}
